import type { LinkForesightProps } from '@pearlconvert/ui/components/link/link-foresight.types'

import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

import { useForesight } from '@pearlconvert/ui/hooks/use-foresight'

export const useLinkForesight = (
  href: LinkForesightProps['href'],
  hitSlop: LinkForesightProps['hitSlop']
) => {
  const router = useRouter()

  const prefetchCallback = useCallback(() => {
    router.prefetch(href as string)
  }, [router, href])

  const { elementRef } = useForesight({
    callback: prefetchCallback,
    hitSlop,
  })

  return {
    elementRef,
  }
}
